import { useContext } from "react";
import Intro from "./components/Intro/Intro";
import Survey from "./components/Survey/Survey";
import AppContext from "./store/app-context";

import "./App.css";

function App() {
  const appCtx = useContext(AppContext);

  return (
    <div className="App">
      {!appCtx.start && <Intro />}
      {appCtx.start && <Survey />}
    </div>
  );
}

export default App;
